<ng-container *ngIf="commit">
  <div class="truncate font-semibold lh-base" [matTooltip]="commit.title">{{ commit.title }}</div>
  <div class="mt-1 flex items-center">
    <y42-user-avatar class="mr-1" [user]="state.user" [userIdentity]="commit.authorEmail" size="18"></y42-user-avatar>
    <div class="truncate fs-07 lh-base">
      {{ commit.authorName }} •
      <y42-time-ago [date]="commit.date" [relativeConfig]="{ showIfDaysDiff: 5, format: timeAgoFormat }"></y42-time-ago>
    </div>
  </div>
</ng-container>
